const getTopCompletion = (completionData) => {
    const completion = completionData;
    return completion;
};

export default getTopCompletion;